/**
 * HowWeHelp — 이렇게 도와드립니다 (5탭 패널)
 *
 * preview/index.html 의 .howhelp 1:1 매칭
 *  - 5개 탭 가로 정렬 (flex-wrap)
 *  - 한 번에 하나의 패널만 보임 (active 클래스)
 *  - 하단에 howhelp-notices 2줄
 *
 * 데이터: HOWHELP_PANELS, HOWHELP_NOTICES (config/constants.ts)
 */
import { useState } from 'react';
import { HOWHELP_PANELS, HOWHELP_NOTICES } from '@/config/constants';

export function HowWeHelp() {
  const [activeId, setActiveId] = useState(HOWHELP_PANELS[0]?.id ?? '');
  const active = HOWHELP_PANELS.find((p) => p.id === activeId) ?? HOWHELP_PANELS[0];

  return (
    <section className="howhelp">
      <div className="section-head">
        <span className="section-tag">HOW WE HELP</span>
        <h2 className="section-title">
          <span className="accent">이렇게</span> 도와드립니다
        </h2>
        <p className="section-sub">각 분야 전담 컨설턴트가 단계별로 진행 방향을 안내합니다.</p>
      </div>

      <div className="howhelp-inner">
        <div className="howhelp-tabs" role="tablist" aria-label="서비스별 진행 방식 선택">
          {HOWHELP_PANELS.map((panel) => {
            const isActive = panel.id === activeId;
            return (
              <button
                key={panel.id}
                type="button"
                role="tab"
                aria-selected={isActive}
                aria-controls={`howhelp-panel-${panel.id}`}
                className={`howhelp-tab${isActive ? ' active' : ''}`}
                onClick={() => setActiveId(panel.id)}
              >
                {panel.label}
              </button>
            );
          })}
        </div>

        {/* 한 번에 하나의 패널만 렌더 (display:none/block 토글 대신 조건부 렌더로 DOM 가볍게) */}
        {active && (
          <div
            id={`howhelp-panel-${active.id}`}
            className="howhelp-panel"
            role="tabpanel"
          >
            <div className="howhelp-panel-sub">{active.sub}</div>
            <h3 className="howhelp-panel-title">{active.title}</h3>
            <p className="howhelp-panel-desc">{active.desc}</p>
            <p className="howhelp-panel-note">{active.note}</p>
          </div>
        )}

        <div className="howhelp-notices">
          {HOWHELP_NOTICES.map((notice, i) => (
            <p key={i} className="howhelp-notice">{notice}</p>
          ))}
        </div>
      </div>
    </section>
  );
}
